import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useActiveWallet } from "thirdweb/react";
import { AccountAssets } from "..";
import { useSimCollectibles } from "../../hooks/index.js";
const NFTContent = () => {
  const $ = _c(7);
  const activeWallet = useActiveWallet();
  let t0;
  if ($[0] !== activeWallet) {
    t0 = activeWallet?.getAccount();
    $[0] = activeWallet;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeAccount = t0;
  const activeAddress = activeAccount?.address;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [1, 8453];
    t2 = {
      filterSpam: true
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  const {
    data: nfts,
    isLoading
  } = useSimCollectibles(activeAddress, t1, t2);
  let t3;
  if ($[4] !== isLoading || $[5] !== nfts) {
    t3 = _jsx("div", {
      style: {
        minHeight: "100px"
      },
      children: nfts ? _jsx(AccountAssets, {
        nfts,
        isLoading
      }) : _jsx("div", {
        className: "py-12 text-center text-gray-500",
        children: "No NFTs found"
      })
    });
    $[4] = isLoading;
    $[5] = nfts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default NFTContent;